import { render, staticRenderFns } from "./VesselMonitoringSingleHatch.vue?vue&type=template&id=081a77fc"
import script from "./VesselMonitoringSingleHatch.vue?vue&type=script&lang=ts"
export * from "./VesselMonitoringSingleHatch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports